// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconMedIcrs_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M10.5185 23.3617C16.247 23.9109 21.7017 20.2624 23.2406 14.519 24.7796 8.77565 21.8799 2.88862 16.6443.5L16.1178 2.46481C20.2869 4.54115 22.5609 9.32833 21.3088 14.0014 20.0566 18.6745 15.6937 21.6833 11.045 21.3969L10.5185 23.3617ZM12.4939.534411C7.22476.304275 2.31633 3.74441.894707 9.04997-.526913 14.3555 2.00385 19.789 6.68215 22.2243L7.21528 20.2346C3.60293 18.1305 1.69255 13.7998 2.82656 9.56761 3.96057 5.33542 7.78037 2.54011 11.9608 2.5241L12.4939.534411Z" class="svg-bg"/>
</svg>
`;
/**
 * IconMedIcrs is a generated icon component.
 */
let IconMedIcrs = IconMedIcrs_1 = class IconMedIcrs extends IconBaseElement {
    render() {
        return html `${IconMedIcrs_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconMedIcrs.icons = new Map([
    ['s8', _s24IconSvg],
    ['s12', _s24IconSvg],
    ['s16', _s24IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconMedIcrs = IconMedIcrs_1 = __decorate([
    customElement('zui-icon-med-icrs')
], IconMedIcrs);
export { IconMedIcrs };
